import { Pause, Play } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { usePauseLink, useResumeLink } from '@/hooks/useLinks';
import type { LinkStatus } from '@/types/api';

interface LinkActionButtonsProps {
  linkId: string;
  status: LinkStatus;
}

export function LinkActionButtons({
  linkId,
  status,
}: LinkActionButtonsProps): React.ReactElement | null {
  const pauseMutation = usePauseLink();
  const resumeMutation = useResumeLink();

  const isLoading = pauseMutation.isPending || resumeMutation.isPending;

  if (status === 'expired') {
    return null;
  }

  if (status === 'active') {
    return (
      <Button
        variant="outline"
        size="sm"
        onClick={(): void => {
          pauseMutation.mutate(linkId);
        }}
        disabled={isLoading}
        className="gap-1"
      >
        <Pause className="h-4 w-4" />
        <span>一時停止</span>
      </Button>
    );
  }

  // status === 'paused'
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={(): void => {
        resumeMutation.mutate(linkId);
      }}
      disabled={isLoading}
      className="gap-1"
    >
      <Play className="h-4 w-4" />
      <span>再開</span>
    </Button>
  );
}
